(function() {
    /**
     * Featured Streamer Service
     * Handles API calls for featured streamer functionality
     */
    window.featuredStreamerService = {
      /**
       * Get featured streamers (public endpoint)
       * Used on homepage and streamers list
       */
      getFeatured() {
        return axios.get('/api/streamer/featured.php');
      },

      /**
       * Get eligible streamers for featuring (admin only)
       * Returns streamers with active subscription + recent activity
       */
      getEligible() {
        return axios.get('/api/admin/streamer/eligible-featured.php');
      },

      /**
       * Set streamer as featured or remove from featured (admin only)
       * @param {Object} data - {twitchId, isFeatured, featuredUntil?, featuredOrder?}
       */
      setFeatured(data) {
        return axios.post('/api/admin/streamer/set-featured.php', data);
      }
    };
})();
